import { withErrorBoundary } from '@sentry/react'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { z } from 'zod'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage.tsx'
import { EveningChannelPage } from '@/pages/messages/EveningChannelPage'
import { parseChannelIdParams } from '@/state/channels/channel'
import { eveningTeamsQuery } from '@/state/regions/regions'

const eveningChannelSearchSchema = z.object({
  regionName: z.string().optional(),
  piloteRegionId: z.number().optional(),
  eveningDate: z.string().optional(),
  regionId: z.string().optional(),
})

export const Route = createFileRoute('/regions/messages/$eveningId/channels/$channelId')({
  params: {
    parse: (params) => {
      const parsed = parseChannelIdParams(params)
      if (!parsed) {
        throw notFound()
      }
      return parsed
    },
  },
  validateSearch: eveningChannelSearchSchema,
  component: withErrorBoundary(EveningChannelPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  loader: async ({ context, params }) => {
    await context.queryClient.fetchQuery(eveningTeamsQuery(Number(params.eveningId)))
  },
  gcTime: 5000,
  wrapInSuspense: true,
})
